module.exports = __webpack_public_path__ + "img/xcx.d0e458d9.jpg";